(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("ln8lv", function(module, exports) {

var $1089O = parcelRequire("1089O");
const $f8f2384b7e2b53f9$var$notifications = document.querySelectorAll(".i-notification");
$f8f2384b7e2b53f9$var$notifications.forEach((notification)=>{
    const closeButtons = notification.querySelectorAll(".i-notification__close");
    closeButtons.forEach((closeButton)=>{
        closeButton.addEventListener("click", ()=>{
            notification.remove();
            (0, $1089O.checkHeaderHeight)();
        });
    });
});

});

})();
//# sourceMappingURL=notification-item.fe3940e1.js.map
